//import {React, useEffect, useState} from "react";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { format } from "date-fns";
import moment from "moment";
import { useSelector } from "react-redux";
// import { saveAs } from 'file-saver';
import bng from "../../assets/Images/bng.png";
import {
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
// import { update } from 'plotly.js';
import { ButtonGroup, Button } from "semantic-ui-react";
import GetAppIcon from "@material-ui/icons/GetApp";
// import kauvery_logo from "../../assets/img/kauvery_logo.jpg";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import axios from "axios";

const styles = (theme) => ({
  loader: {
    size: "40px",
    color: "#26c6da",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  select: {
    "&:after": {
      borderBottomColor: "blue",
      marginTop: "-2vh",
      fontWeight: "bold",
      borderRadius: "0.8vw",
      "&:focus": {
        backgroundColor: "transparent", // Remove background color on focus
        boxShadow: "none", // Remove shadow on focus
      },
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root ": {
      marginTop: "-2vh",
    },
    menuPaper: {
      boxShadow: "none", // Remove shadow in the dropdown menu
    },
  },
});
const useStyles = makeStyles(styles);

function getColumns(myheading = null, isDeviceReports = false) {
  // Keep 'Time' in default heading, only remove 'measured_time'
  myheading =
    myheading === null
      ? {
        DeviceName: "DeviceName",
        date: "Date",
        Time: "Time",
        ParameterName: "ParameterName",
        // Key: "Key",
        Value: "Value",
        // Unit: "Unit",
      }
      : myheading;

  if (isDeviceReports) {
    // Add Time field back to Device Reports
    return [
      {
        field: "Date",
        width: "100px",
        sortable: true,
        lockPosition: "left",
        cellStyle: { "border-right-color": "#e2e2e2" },
      },
      {
        field: "DeviceName",
        width: "150px",
        sortable: true,
        lockPosition: "left",
        cellStyle: { "border-right-color": "#e2e2e2" },
      },
      {
        field: "Parameter",
        width: "100px",
        sortable: true,
        lockPosition: "left",
        cellStyle: { "border-right-color": "#e2e2e2" },
      },
      {
        field: "Time",
        width: "100px",
        sortable: true,
        filter: "agNumberColumnFilter",
        lockPosition: "left",
        cellStyle: { "border-right-color": "#e2e2e2" },
      },
      {
        field: "Description",
        width: "500px",
        sortable: true,
        lockPosition: "left",
        cellStyle: { "border-right-color": "#e2e2e2" },
      },
    ];
  }

  let mykeys = Object.keys(myheading);
  // Filter out only measured_time related keys, keep regular time
  mykeys = mykeys.filter(
    (key) => !["measured_time", "MeasuredTime", "MEASURED_TIME"].includes(key)
  );

  let columnDefs = [];
  for (let i = 0; i < mykeys.length; i++) {
    switch (mykeys[i]) {
      case "DeviceName":
        columnDefs.push({
          field: mykeys[i],
          filter: "agNumberColumnFilter",
          width: "150px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
        break;
      case "Possible_causes":
        columnDefs.push({
          field: mykeys[i],
          width: "400px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
        break;
      case "Timestamp":
        columnDefs.push({
          field: mykeys[i],
          filter: "agDateColumnFilter",
          width: "100px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
        break;
      case "Date":
        columnDefs.push({
          field: mykeys[i],
          filter: "agDateColumnFilter",
          width: "100px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
        break;
      case "Time":
        columnDefs.push({
          field: mykeys[i],
          filter: "agDateColumnFilter",
          width: "100px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
        break;
      case "created_at":
      case "Acknowledged":
      case "Ignore_alarm":
      case "Category":
      case "Criticality":
      case "triggered_time":
      case "Ignore":
      case "Modified_at":
      case "ActiveTime_in_sec":
        // Skip these fields - don't create columns for them
        break;
      default:
        columnDefs.push({
          field: mykeys[i],
          filter: true,
          sortable: true,
          flex: "1",
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        });
    }
  }

  return columnDefs;
}

function prepareReportData(rData, reportType) {
  if (!rData || rData.length === 0) {
    return { Headings: [], RowData: [] };
  }

  if (reportType === "RunHours") {
    rData = rData.map((item) => {
      return {
        "Equipment Name": item.device_name,
        "Run Hours": item.run_hour,
      };
    });
  } else {
    rData = rData.map((r_d) => {
      if (r_d.created_at) {
        let mes_time = r_d.created_at.split(" ");
        r_d.date = mes_time[0];
        r_d.time = mes_time[1]; // Keep creating time field
      }

      // Remove only measured_time related fields, keep regular time
      const {
        measured_time,
        MeasuredTime,
        MEASURED_TIME,
        created_at,
        ...cleanData
      } = r_d;
      return cleanData;
    });
  }

  return { Headings: getColumns(rData[0]), RowData: rData };
}
function prepareUserReportData(rData, reportType) {
  rData.map((r_d) => {
    let mes_time = r_d["triggered_time"].split(" ");
    r_d.date = mes_time[0];
    r_d.time = mes_time[1];
  });

  return { Headings: getColumns(rData[0]), RowData: rData };
}
function prepareUserLoginReportData(rData) {
  rData.map((r_d) => {
    console.log("dddddddddddddddddd", r_d);
    const time = new Date(0, 0, 0);
    time.setMinutes(r_d["ActiveTime_in_mins"]);
    console.log("time.getMinutes()", time.getMinutes());
    r_d.ActiveTime = time.getHours() + ":" + time.getMinutes();
  });
  return { Headings: getColumns(rData[0]), RowData: rData };
}

const staticData = [
  {
    DeviceName: "Device 1",
    date: "2023-08-07",
    time: "12:00:00",
    Category: "Category A",
    Key: "Key 1",
    Value: 123,
    Unit: "Units",
  },
  {
    DeviceName: "Device 2",
    date: "2023-08-07",
    time: "13:30:00",
    Category: "Category B",
    Key: "Key 2",
    Value: 456,
    Unit: "Units",
  },
  // ... add more static data objects ...
];
function GlEventsViewer() {
  let reportOptions = [
    // { "option": "ibmsevents", "title": "IBMS LOGS", "api": 'ibmsevents_table' },
    {
      option: "UserLoginReport",
      title: "User Login Report",
      api: "loginLogoutDetails",
    },
    { option: "Device Reports", title: "Device Report" },
    // {
    //   option: "DeviceCritical",
    //   title: "Device Critical Alarms",
    //   api: "alarmDeviceCritical",
    // },
    // {"option":"DeviceTypeCritical","title":"DeviceType Critical","api":'alarmDeviceTypeCritical'},
    // { "option": "mostActiveAlarmCritical", "title": "Most Active Critical Alarms", "api": 'mostActiveAlarmCritical' },
    // {
    //   option: "restorecriticalalarms",
    //   title: "Critical Alarms Restored",
    //   api: "criticalAlarmRestored",
    // },
    // {
    //   option: "alarmDevice",
    //   title: "Device NonCritical Alarms",
    //   api: "alarmDeviceNonCritical",
    // },
    // {"option":"alarmDeviceType","title":"DeviceType Alarms","api":'alarmDeviceTypeNonCritical'},
    // { "option": "mostActiveAlarmNonCritical", "title": "Most Active NonCritical Alarms", "api": 'mostActiveAlarmNonCritical' },
    // {
    //   option: "restorenoncriticalalarms",
    //   title: "Non-Critical Alarms Restored",
    //   api: "nonCriticalAlarmRestored",
    // },
    // { "option": "TrendLogComparisionReport", "title": "Trend Log Comparision Report", "api": 'TrendLogComparisionReport' },
    // { "option": "scheduleActivityReport", "title": "AHU Schedule Activity Report", "api": 'scheduleActivityReport' },
    // { "option": "ActivitesperuserReport", "title": "Activites Per User Report", "api": 'ActivitesperuserReport' },
    // { "option": "ActivitesperserverReport", "title": "Activites Per Server Report", "api": 'ActivitesperserverReport' },
    // {
    //   option: "UserControlDetails",
    //   title: "User Contol Details",
    //   api: "userDetails",
    // },
    // {
    //   option: "AcknowledgedUser",
    //   title: "Alarms Acknowledged By User",
    //   api: "acknowledgedUser",
    // },
    // {
    //   option: "IgnoredUser",
    //   title: "Alarms Ignored By User",
    //   api: "ignoredUser",
    // },
    { option: "RunHours", title: "Run Hours", api: "RunHours" },
  ];
  // const[reportOptions,setReportOptions]=useState(reports);
  // const [headings,setHeadings]=useState(getColumns());

  const classes = useStyles();
  const gridRef = useRef();
  // const [eventdata,setEventData]=React.useState([]);
  const [reportData, setReportData] = React.useState({
    Headings: getColumns(),
    RowData: [],
  });
  // const [selectedRows, setSelectedRows] = useState();
  const [isloaded, setIsLoaded] = React.useState(true);
  const [stitle, setStitle] = useState("Device Reports");
  const [fdata, setFdata] = useState(localStorage.getItem("floorName"));
  const [floor, setFloor] = useState([]);
  const [fid, setFId] = useState("");
  const buildingID = useSelector((state) => state.isLogged.data.building.id);
  const [age, setAge] = React.useState("");
  const [age1, setAge1] = React.useState("");
  const [age3, setAge3] = React.useState("");
  const data = useSelector((state) => state.inDashboard.locationData);
  const [bid, setBId] = useState(localStorage.getItem("buildingID"));
  const [fname, setFName] = useState([]);
  const [dname, setDName] = useState([]);
  const [bdata, setBdata] = useState([]);
  const [ddata, setDData] = useState([]);
  const [bname, setBName] = useState([]);
  const [extractedDevices, setExtractedDevices] = useState([]);
  const [deviceid, setDeviceid] = useState();
  const [tableData, setTableData] = useState([]);
  const [week1, setWeek1] = useState([]);
  const [month1, setMonth1] = useState([]);
  const [month3, setMonth3] = useState([]);
  const [month6, setMonth6] = useState([]);
  const [year1, setYear1] = useState([]);
  const [format, setFormat] = useState([]);
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [selectedBuilding, setSelectedBuilding] = useState("");
  const [equipmentTypes, setEquipmentTypes] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState("");
  const [deviceNames, setDeviceNames] = useState([]);
  const [deviceids, setDeviceids] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [selectedDeviceName, setSelectedDeviceName] = useState("");
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [selectedBuildingName, setSelectedBuildingName] = useState("");
  const [floorOptions, setFloorOptions] = useState([""]);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [apiResponse, setApiResponse] = useState("");
  const [isEquipmentDisabled, setIsEquipmentDisabled] = useState(true);
  const [availableDeviceTypes, setAvailableDeviceTypes] = useState([]);
  const EqpArr = [
    { ss_type: "NONGL_SS_ENERGY_METER_UPS", name: "UPSEnergy Meters" },
    { ss_type: "NONGL_SS_DG_ENERGY_METER", name: "DGEnergyMeters" },
    {
      ss_type: "NONGL_SS_ENERGY_METER_LIGHT_AND_POWER",
      name: "Light and Power Energy Meters",
    },
    {
      ss_type: "NONGL_SS_ENERGY_METER_LT_PANEL",
      name: "LT Panel Energy Meters",
    },
    {
      ss_type: "NONGL_SS_ENERGY_METER_SDB_EMERGENCY",
      name: "SDB Energy Meters",
    },
    {
      ss_type: "NONGL_SS_ENERGY_METER_CAR_CHARGER",
      name: "Car Charger energy Meters",
    },
    {
      ss_type: "NONGL_SS_ENERGY_METER_LIFT",
      name: "LiftEnergyMeters",
    },
    {
      ss_type: "NONGL_SS_RO_PLANT",
      name: "RO Plant",
    },
    {
      ss_type: "NONGL_SS_HYDROPNEUMATIC_RO_PUMP",
      name: "Hydropneumatic Pump",
    },
    {
      ss_type: "NONGL_SS_AHU",
      name: "AHU",
    },
    {
      ss_type: "NONGL_SS_DISEL_PUMP",
      name: "Diesel Pump",
    },
    {
      ss_type: "NONGL_SS_UPS_1PHASE",
      name: "UPS 1 Phase",
    },
    {
      ss_type: "NONGL_SS_AIR_QUALITY_MONITOR_SYSTEM",
      name: "Air Quality Monitor System",
    },
    {
      ss_type: "NONGL_SS_UPS",
      name: "UPS",
    },
    {
      ss_type: "NONGL_SS_TRANSFORMER",
      name: "Transformer",
    },
    {
      ss_type: "NONGL_SS_ENERGY_METER_TRANSFORMER",
      name: "Energy meter Transformer",
    },
    {
      ss_type: "NONGL_SS_DG",
      name: "DG",
    },
    {
      ss_type: "NONGL_SS_SOLAR_PV_PLANT",
      name: "Solar PV plant",
    },
    {
      ss_type: "NONGL_SS_FIRE_SEPARATION_SYSTEM",
      name: "Fire Suppression",
    },
    {
      ss_type: "SS_INLINE_FAN",
      name: "Inline Fan",
    },
    {
      ss_type: "NONGL_SS_WLD",
      name: "WLD",
    },
    {
      ss_type: "NONGL_SS_TFA",
      name: "TFA",
    },
    {
      ss_type: "SS_EXHAUST_FAN",
      name: "Exhaust Fan",
    },
    {
      ss_type: "NONGL_SS_FIRE_ALARM_SYSTEM",
      name: "Fire Alarm",
    },
    {
      ss_type: "NONGL_SEWAGE_PUMP",
      name: "Sewage Pump",
    },
    {
      ss_type: "NONGL_SUMP_PUMP",
      name: "Sump Pump",
    },
    {
      ss_type: "NONGL_WATER_PUMP",
      name: "Water Pump",
    },
    {
      ss_type: "NONGL_SCOOTER_LIFT",
      name: "Scooter Lift",
    },
    {
      ss_type: "NONGL_FIRE_FIGHTING_PUMP",
      name: "Fire Fighting Pump",
    },
    {
      ss_type: "NONGL_SS_EMS",
      name: "Energy Meters",
    },
    {
      ss_type: "NONGL_SS_TANK_LEVEL",
      name: "Energy Meters",
    },
    {
      ss_type: "NONGL_WATER_TANK",
      name: "Water Tank",
    },

    // { ss_type: "NONGL_SS_AIR_COOLED_CHILLER", name: "Air Cooled Chiller" },
    // { ss_type: "NONGL_SS_AIR_COOLED_HEADER", name: "Air Cooled Header" },
    // { ss_type: "NONGL_SS_CPM", name: "CPM" },
    // { ss_type: "NONGL_SS_CSU", name: "CSU" },
    // { ss_type: "NONGL_SS_DPT_Device", name: "DPT device" },
    // { ss_type: "NONGL_SS_HEADER", name: "Header" },
    // { ss_type: "NONGL_SS_PUMPS", name: "Pumps" },
    // { ss_type: "NONGL_SS_PRIMARY_VARIABLE_PUMPS", name: "Primary Pumps" },
  ];
  const [floors, setFloors] = useState([]); // Store floors
  const [zones, setzones] = useState([]);
  const [filteredEquipmentTypes, setFilteredEquipmentTypes] = useState([]);
  const [filteredDeviceList, setFilteredDeviceList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true); // Initially disabled

  const [selectedDeviceParams, setSelectedDeviceParams] = useState([]);
  const [deviceParameters, setDeviceParameters] = useState([]);
  const [devParamReports, setDevParamReports] = useState([]);

  const parameterMap = {
    NONGL_SS_AHU: [
      "RARH",
      "SAF_VFD_Speed",
      "UVGI_Cntrl",
      "UVGI_Cntrl_SS",
      "RAT",
      "AHU_Run_SS",
      "SAF_VFD_Speed_Fbk",
      "AHU_Schedule",
      "SAF_VFD_On_Off_Fbk",
      "Post_Filter_SS",
      "Post_Filter_SS",
      "AHU_Temp",
      "Heater_Bank_2_Status",
      "SAF_VFD_On_Off",
      "Heater_Bank_1_Status",
      "OAT",
      "Electric_Heater_Ctrl",
      "DSP",
      "AHU_Speed_Feedback",
      "AHU_AM_SS",
      "Electric_Heater_Cntrl_SS",
      "CHW_Vlv_Pos_SP",
      "SAT",
      "DPS_Filter",
      "AHU_On_Off_SS_Panel",
      "Heater_Bank_3_Status",
      "SAF_VFD_AM_Fbk",
      "SAF_VFD_Trip_SS_Alarm",
      "CHW_Vlv_Pos",
      "AHU_Trip_SS_Alarm",
      "AHU_Manual_CMD",
      "AHU_ONOFF_CMD",
      "AHU_Filter_SS",

    ],
    NONGL_SS_DISEL_PUMP: [
      "DISEL_Am_SS"
    ],

    NONGL_SS_UPS_1PHASE: [
      "UPS_BATERRY_",
      "UPS_I/P_VOLTAGE",
      "UPS_O/P_Current",
      "UPS_Temp",
      "UPS_Online",
      "UPS_O/P_Freq",
      "UPS_SS",
      "UPS_I/P_FREQUINCY",
      "UPS_WLD",
      "UPS_O/P_LOAD%",
      "UPS_O/P_Volt"
    ],
    NONGL_SS_AIR_QUALITY_MONITOR_SYSTEM: [
      "AQI_Base_CO2",
      "AQI_Base_Temp",
      "AQI_Base_RH",
      "AQI_Base_PM2.5"
    ],
    SS_EXHAUST_FAN: [
      "EXHAUST_FAN_Run_SS",
      "EXHAUST_FAN_On_Off_SS",
      "EXHAUST_Base_Schedule",
      "EXHAUST_FAN_On_Off_Cmd",
      "EXHAUST_FAN_AM_SS",
      "EXHAUST_BASE_Manual_Cmd",
    ],
    NONGL_SS_TFA: [
      "TFA_VFD_Speed_Feedback ",
      "TFA_Schedule",
      "TFA_On_Off_Cmd",
      "TFA_RUN_SS",
      "TFA_VFD_Speed_Ctrl",
      "TFA_VFD_Integration",
      "TFA_Trip_SS_Alarm",
      "TFA_AM_SS",
      "TFA_Speed_Feedback",
      "TFA_Filter_SS",
      "TFA_CHW_Mtr_Vlv_Mod",
      "TFA_Supply_Temp",
      "TFA_Manual_Cmd",

    ],
    NONGL_SS_FIRE_ALARM_SYSTEM: [
      "Fire_Alarm",
      "Fire_Sprinkler_Hydrant_Line_Pressure_Mnt",
      "Fire_Pmp_Trip_SS_Alarm",
      "Fire_Pmp_RUN_SS",
    ],
    SS_INLINE_FAN: [
      "Inline_Fan_Schedule",
      "Inline_Fan_On_Off_Cmd",
      "Inline_Fan_AM_SS",
      "Inline_Fan_RUN_SS",
      "Inline_Fan_Manual_Cmd",
    ],
    NONGL_SEWAGE_PUMP: [
      "SEWAGE_P_UNDER_VOLTAGE",
      "SEWAGE_P_OVER_VOLTAGE",
      "SEWAGE_P_A_RUNNING",
      "SEWAGE_P_B_RUNNING",
      "SEWAGE_P_AUTO",
      "SEWAGE_P_MANUAL",
    ],
    NONGL_SUMP_PUMP: [
      "SUMP_Pmp_MOTOR_A_Off_SS",
      "SUMP_Pmp_MOTOR_B_Trip_SS",
      "SUMP_Pmp_MOTOR_A_On_Off_SS",
      "SUMP_Pmp_MOTOR_B_Off_SS",
      "SUMP_Pmp_MOTOR_B_On_Off_SS",
      "SUMP_Pmp_MOTOR_B_On_SS",
      "SUMP_Pmp_MOTOR_A_Trip_Alarm",
      "SUMP_Pmp_MOTOR_A_On_SS",
    ],
    NONGL_WATER_PUMP: [
      "WATER_Pmp_B_RUNNING",
      "WATER_Pmp_Manual",
      "WATER_Pmp_A_RUNNING",
      "WATER_Pmp_Auto",
      "Water_Pmp_Hp_On_Off_SS",
      "Water_Pmp_Drive_Trip_SS_Alarm",
    ],
    NONGL_SCOOTER_LIFT: ["Scooter_ON_OFF_SS", "Scooter_Trip_SS_Alarm"],
    NONGL_SS_EMS: [
      "EM_VRB_METER_current_PHASE_Y",
      "EM_Firefighting_phase_volt_RB",
      "VRB_METER_volt_phase_B",
      "EM_Firefighting_PF",
      "EM_FREQ_VRB_METER",
      "EM_Firefighting_Freq",
      "EM_VRB_METER_VOLT_L_L_Avg",
      "EM_Firefighting_phase_volt_YB",
      "EM_Firefighting_phase_curent_B",
      "EM_Firefighting_phase_volt_RY",
      "EM_VRV_PF",
      "EM_Firefighting_kw",
      "EM_Firefighting_phase_curent_R",
      "EM_Cur_Avg",
      "EM_VRB_METER_current_phase_B",
      "EM_VRV_KW",
      "EM_VRB_METER_current_phase_R",
      "EM_VRV_KWH",
      "EM_Firefighting_phase_curent_Y",
      "EM_VRB_METER_VOLT_L_N_Avg",
      "EM_VRB_METER_volt_PHASE_Y",
      "EM_VRB_METER_volt_phase_R",
      "EM_Firefighting_Kwh",
    ],
    NONGL_FIRE_FIGHTING_PUMP: [
      "Fire_Pmp_Hydrant_pump_AM_SS",
      "Fire_Pmp_Sprinkler_Trip_SS_Alarm",
      "Fire_Pmp_Jockey_Pump_Trip_SS_Alarm",
      "Fire_Pmp_Sprinkler_Run_SS",
      "Fire_Pmp_SPINKLER_AM_SS",
      "Fire_Pmp_Jockey_Pump_Run_SS",
      "Fire_Pmp_Hydrent_Run_SS",
      "Fire_Pmp_Jockey_Pump_AM_SS",
      "Fire_Pmp_Hydrent_Trip_SS_Alarm",
      "Fire_Pmp_Hydrent_Line_PressureA",
      "Fire_Pmp_Sprinkler_Line_PressureA"

    ],
    NONGL_SS_DG: [
      "DG_Microprocess",
      "DG_Current_Y_Phase",
      "DG_Oil_Mid_Level",
      "DG_Run_SS",
      "DG_Metering_WH",
      "DG_On_Off_SS",
      "DG_On_SS",
      "DG_AV_PF",
      "DG_Metering_Y_Phase",
      "DG_Off_SS",
      "DG_Metering_B_Phase",
      "DG_Trip_SS_Alarm",
      "DG_Weekly_Energy",
      "DG_Total_Current",
      "DG_OIL_Low_Lvl_SS",
      "DG_Current_R_Phase",
      "DG_Battery_SS",
      "DG_Metering_R_Phase",
      "DG_Power_Factor",
      "DG_Load",
      "DG_Frequency",
      "DG_Metering_Frequency",
      "DG_Daily_Energy",
      "DG_OIL_High_Lvl_SS",
      "DG_Monthly_Energy",
      "DG_Yearly_Energy",
      "DG_Current_B_Phase",
      "DG_WATT",
    ],
    NONGL_SS_ENERGY_METER_LIFT: [
      "EM_LIFT_RM_Y_Phase",
      "EM_LIFT_RM_B_Phase",
      "EM_Lift_Current_Y_Phase",
      "EM_Lift_Total_Current",
      "EM_Lift_Current_R_Phase",
      "EM_LIFT_RM_WH",
      "EM_Lift_WATT",
      "EM_Lift_AV_PF",
      "EM_LIFT_RM_R_Phase",
      "EM_LIFT_RM_Freq",
      "EM_Lift_Current_B_Phase",
    ],
    NONGL_SS_ENERGY_METER_LT_PANEL: [
      "EM_LT_Current_R_Phase",
      "EM_LT_WATT",
      "EM_LT_PANEL_Freq",
      "EM_LT_PANEL_B_PHASE",
      "EM_LT_Current_Y_Phase",
      "EM_LT_Total_Current",
      "EM_LT_PANEL_WH",
      "EM_LT_Current_B_Phase",
      "EM_LT_AV_PF",
      "EM_LT_PANEL_R_PHASE",
      "EM_LT_PANEL_Y_PHASE ",
    ],
    NONGL_SS_ENERGY_METER_TRANSFORMER: [
      "EM_TR_Freq",
      "EM_TR_Y_Phase",
      "EM_TR_AV_PF",
      "EM_TR_WH",
      "EM_TR_Current_Y_Phase",
      "EM_TR_Current_B_Phase",
      "EM_TR_Watt",
      "EM_TR_Total_Current",
      "EM_TR_Current_R_Phase",
      "EM_TR_B_Phase",
      "EM_TR_R_Phase",
    ],
    NONGL_SS_ENERGY_METER_LIGHT_AND_POWER: [
      "EM_Light_Power_Schnider_meter_Freq",
      "EM_Light_Power_Schnider_meter_phase_volt_Y_B",
      "EM_Light_Power_Schnider_PF",
      "EM_Light_Power_Schnider_meter_phase_volt_R_B",
      "EM_Light_Power_Schnider_meter_phase_curent_Y",
      "EM_Light_Power_Schnider_kw",
      "EM_Light_Power_Schnider_meter_phase_curent_B",
      "EM_Light_Power_Schnider_meter_phase_curent_R",
      "EM_Light_Power_Schnider_Meter_Kwh",
      "EM_Light_Power_Schnider_meter_phase_volt_R_Y",
    ],
    NONGL_SS_ENERGY_METER_UPS: [
      "EM_UPS_Schnider_kw ",
      "EM_UPS_Schnider_meter_phase_curent_R",
      "EM_UPS_Current_Total ",
      "EM_UPS_Current_Y_PHASE",
      "EM_UPS_Watt",
      "EM_UPS_V_R_PHASE",
      "EM_UPS_AV_PF",
      "EM_UPS_Schnider_PF",
      "EM_UPS_Schnider_Meter_1_KWH",
      "EM_UPS_V_B_PHASE",
      "EM_UPS_Schnider_meter_phase_volt_Y_B",
      "EM_UPS_Current_B_Phase",
      "EM_UPS_Freq",
      "EM_UPS_Schnider_meter_phase_volt_R_B",
      "EM_UPS_Schnider_meter_phase_volt_R_Y",
      "EM_UPS_WH",
      "EM_UPS_V_Y_PHASE",
      "EM_UPS_Current_R_Phase",
      "EM_UPS_Schnider_meter_phase_curent_Y",
      "EM_UPS_Schnider_meter_Freq",
      "EM_UPS_Schnider_meter_phase_curent_B",
    ],
    NONGL_SS_ENERGY_METER_SDB_EMERGENCY: [
      "EM_SDB_Emergency_Schnider_PF",
      "EM_SDB_Emergency_Schnider_kw",
      "EM_SDB_Emergency_Schnider_meteR_phase_volt_R_Y",
      "EM_SDB_Emergency_Schnider_meter_phase_volt_Y_B",
      "EM_SDB_Emergency_Schnider_meter_phase_volt_R_B",
      "EM_SDB_Emergency_Schnider_meter_FREQ",
      "EM_SDB_Emergency_Schnider_meter_phase_curent_R",
      "EM_SDB_Emergency_Schnider_meter_phase_curent_Y",
      "EM_SDB_Emergency_Schnider_meter_phase_curent_B",
    ],
    NONGL_SS_ENERGY_METER_CAR_CHARGER: [
      "EM_CAR_Charger_Freq",
      "EM_CAR_Charger_V_R_PHASE",
      "EM_CAR_Charger_V_Y_PHASE",
      "EM_CAR_Charger_V_B_PHASE",
      "EM_CAR_Charger_WH",
      "EM_CAR_Charger_Current_R_Phase",
      "EM_CAR_Charger_Current_Y_Phase",
      "EM_CAR_Charger_Current_B_Phase",
      "EM_CAR_Charger_WATT",
      "EM_CAR_Charger_Total_Current",
      "EM_CAR_Charger_AV_PF",
    ],
    NONGL_SS_DG_ENERGY_METER: [
      "DG_EM_Metering_R_Phase",
      "DG_EM_Metering_Y_Phase",
      "DG_EM_Metering_B_Phase",
      "DG_EM_Metering_WH",
      "DG_EM_Current_R_Phase",
      "DG_EM_Current_Y_Phase",
      "DG_EM_Current_B_Phase",
      "DG_EM_Total_Current",
      "DG_EM_Frequency",
      "DG_EM_Power_Factor",
      "DG_EM_Load",
      "DG_EM_Metering_Freq",
      "DG_EM_WATT",
      "DG_EM_AV_PF",
    ],
    NONGL_SS_TANK_LEVEL: ["TANK_High_SS", "TANK_Low_SS"],
    NONGL_SS_RO_PLANT: [
      "RP_AM_SS",
      "RP_On_Off_Cmd",
      "RP_Run_SS",
      "RP_Trip_SS_Alarm",
      "RO_On_Off_SS",
    ],
    // NONGL_SS_AHU: [
    //   "SAT",
    //   "RAT",
    //   "RARH",
    //   "DSP",
    //   "CHW_Vlv_Pos",
    //   "SAF_VFD_On_Off_Fbk",
    //   "SAF_VFD_Speed_Fbk",
    //   "SAF_VFD_On_Off",
    //   "Electric_Heater_Ctrl",
    //   "UVGI_Cntrl",
    //   "SAF_VFD_Speed",
    //   "CHW_Vlv_Pos_SP",
    //   "Electric_Heater_Cntrl_SS",
    //   "UVGI_Cntrl_SS",
    //   "OAT",
    //   "SAF_VFD_AM_Fbk",
    //   "SAF_VFD_Trip_SS_Alarm",
    //   "DPS_Filter",
    //   "Post_Filter_SS",
    //   "Heater_Bank_1_Status",
    //   "Heater_Bank_2_Status",
    //   "AHU_On_Off_SS_Panel",
    //   "Heater_Bank_3_Status",
    //   "AHU_Temp",
    //   "AHU_Speed_Feedback",
    //   "AHU_Manual_CMD",
    //   "AHU_Schedule",
    //   "AHU_AM_SS",
    //   "AHU_Trip_SS_Alarm",
    //   "AHU_Run_SS",
    //   "AHU_Filter_SS",
    //   "AHU_ONOFF_CMD",
    // ],
    NONGL_SS_HYDROPNEUMATIC_RO_PUMP: [
      "HPP_Booster_P_Manual",
      "HPP_Booster_P_Auto",
      "HPP_Booster_P_A_Running",
      "HPP_Booster_P_B_Running",
    ],
    NONGL_SS_UPS: [
      "UPS_INPUT_V_R_Phase",
      "UPS_INPUT_V_Y_Phase",
      "UPS_INPUT_V_B_Phase",
      "UPS_INPUT_Freq",
      "UPS_O/P_V_R_Phase",
      "UPS_O/P_V_Y_Phase",
      "UPS_O/P_V_B_Phase",
      "UPS_O/P_Freq",
      "UPS_O/P_C_R_Phase",
      "UPS_O/P_C_Y_Phase",
      "UPS_O/P_C_B_Phase",
      "UPS_POWER_R_Phase",
      "UPS_POWER_Y_Phase",
      "UPS_POWER_B_Phase",
      "UPS_LOAD_R_Phase",
      "UPS_LOAD_Y_Phase",
      "UPS_LOAD_B_Phase",
      "UPS_Battery_Volt",
      "UPS_O/P_Volt",
      "UPS_O/P_Current",
      "UPS_O/P_LOAD%",
      "UPS_Temp",
      "UPS_SS",
      "UPS_BATERRY_%",
      "UPS_Online",
      "UPS_I/P_VOLTAGE",
      "UPS_I/P_FREQUINCY",
      "UPS_WLD ",
    ],
    NONGL_SS_TRANSFORMER: [
      "TRF_On_Off_SS",
      "TRF_Trip_SS_Alarm",
      "TRF_Wnd_Temp_High_Alarm",
      "TRF_on_SS",
      "TRF_off_SS",
    ],
    NONGL_SS_SOLAR_PV_PLANT: [
      "Solar_Today_Solar_Energy",
      "Solar_Total_Solar_Energy",
      "Solar_Freq",
      "Solar_Active_Power",
      "Solar_Phase_Volt",
      "Solar_Phase_Current",
      "Solar_PV_Volt",
      "Solar_PV_Current",
    ],
    NONGL_WATER_TANK: ["Water_Tank_High_Lvl_SS", "Water_Tank_Low_Lvl_SS"],
    NONGL_SS_FIRE_SEPARATION_SYSTEM: ["Fire_Separation_System_Device"],
    NONGL_SS_WLD: [
      "WLD_Faulty",
      "WLD_Healthy",
      "WLD_Isolate",
      "WLD_Disable",
      "WLD_Alarm",
      "WLD_S_RM",
    ],
  };

  const parameterUnitMap = {
    // temperature parameters
    "RARH": "%",
    "RAT": "°C",
    "SAT": "°C",
    "OAT": "°C",
    "AHU_Temp": "°C",
    "TFA_Supply_Temp": "°C",
    "UPS_Temp": "°C",


    // Speed/Frequency parameters
    "SAF_VFD_Speed": "rpm",
    "SAF_VFD_Speed_Fbk": "rpm",
    "AHU_Speed_Feedback": "rpm",
    "TFA_VFD_Speed_Feedback": "rpm",
    "TFA_VFD_Speed_Ctrl": "rpm",
    "TFA_Speed_Feedback": "rpm",
    "DG_Frequency": "Hz",
    "DG_Metering_Frequency": "Hz",
    "EM_FREQ_VRB_METER": "Hz",
    "EM_Firefighting_Freq": "Hz",
    "UPS_INPUT_Freq": "Hz",
    "UPS_O/P_Freq": "Hz",
    "Solar_Freq": "Hz",
    "EM_TR_Freq": "Hz",
    "EM_LT_PANEL_Freq": "Hz",
    "EM_UPS_Freq": "Hz",
    "DG_EM_Metering_Freq": "Hz",
    "EM_LIFT_RM_Freq": "Hz",



    // Pressure parameters
    "DSP": "Kpa",
    "DPS_Filter": "",
    "Fire_Sprinkler_Hydrant_Line_Pressure_Mnt": "Kpa",


    // Valve position parameters
    "CHW_Vlv_Pos": "",
    "CHW_Vlv_Pos_SP": "",
    "TFA_CHW_Mtr_Vlv_Mod": "",

    // Voltage parameters
    "EM_VRB_METER_volt_phase_B": "V",
    "EM_Firefighting_phase_volt_RB": "V",
    "EM_Firefighting_phase_volt_YB": "V",
    "EM_Firefighting_phase_volt_RY": "V",
    "EM_VRB_METER_VOLT_L_L_Avg": "V",
    "EM_VRB_METER_VOLT_L_N_Avg": "V",
    "EM_VRB_METER_volt_PHASE_Y": "V",
    "EM_VRB_METER_volt_phase_R": "V",
    "UPS_INPUT_V_R_Phase": "V",
    "UPS_INPUT_V_Y_Phase": "V",
    "UPS_INPUT_V_B_Phase": "V",
    "UPS_O/P_V_R_Phase": "V",
    "UPS_O/P_V_Y_Phase": "V",
    "UPS_O/P_V_B_Phase": "V",
    "UPS_Battery_Volt": "V",
    "UPS_O/P_Volt": "V",
    "UPS_I/P_VOLTAGE": "V",
    "Solar_Phase_Volt": "V",
    "Solar_PV_Volt": "V",
    "DG_Metering_R_Phase": "V",
    "DG_Metering_Y_Phase": "V",
    "DG_Metering_B_Phase": "V",
    "EM_LIFT_RM_Y_Phase": "V",
    "EM_LIFT_RM_B_Phase": "V",
    "EM_LIFT_RM_R_Phase": "V",
    "EM_LT_PANEL_B_PHASE": "V",
    "EM_LT_PANEL_R_PHASE": "V",
    "EM_LT_PANEL_Y_PHASE": "V",
    "EM_TR_Y_Phase": "V",
    "EM_TR_B_Phase": "V",
    "EM_TR_R_Phase": "V",
    "EM_UPS_V_R_PHASE": "V",
    "EM_UPS_V_B_PHASE": "V",
    "EM_UPS_V_Y_PHASE": "V",
    "EM_CAR_Charger_V_R_PHASE": "V",
    "EM_CAR_Charger_V_Y_PHASE": "V",
    "EM_CAR_Charger_V_B_PHASE": "V",
    "DG_EM_Metering_R_Phase": "V",
    "DG_EM_Metering_Y_Phase": "V",
    "DG_EM_Metering_B_Phase": "V",


    // Current parameters
    "EM_VRB_METER_current_PHASE_Y": "A",
    "EM_VRB_METER_current_phase_B": "A",
    "EM_VRB_METER_current_phase_R": "A",
    "EM_Firefighting_phase_curent_B": "A",
    "EM_Firefighting_phase_curent_R": "A",
    "EM_Firefighting_phase_curent_Y": "A",
    "EM_Cur_Avg": "A",
    "DG_Current_Y_Phase": "A",
    "DG_Current_R_Phase": "A",
    "DG_Current_B_Phase": "A",
    "DG_Total_Current": "A",
    "EM_Lift_Current_Y_Phase": "A",
    "EM_Lift_Current_R_Phase": "A",
    "EM_Lift_Current_B_Phase": "A",
    "EM_Lift_Total_Current": "A",
    "EM_LT_Current_R_Phase": "A",
    "EM_LT_Current_Y_Phase": "A",
    "EM_LT_Current_B_Phase": "A",
    "EM_LT_Total_Current": "A",
    "EM_TR_Current_Y_Phase": "A",
    "EM_TR_Current_B_Phase": "A",
    "EM_TR_Current_R_Phase": "A",
    "EM_TR_Total_Current": "A",
    "UPS_O/P_C_R_Phase": "A",
    "UPS_O/P_C_Y_Phase": "A",
    "UPS_O/P_C_B_Phase": "A",
    "UPS_O/P_Current": "A",
    "Solar_Phase_Current": "A",
    "Solar_PV_Current": "A",
    "DG_EM_Current_R_Phase": "A",
    "DG_EM_Current_Y_Phase": "A",
    "DG_EM_Current_B_Phase": "A",
    "DG_EM_Total_Current": "A",
    "EM_UPS_Current_Total": "A",
    "EM_UPS_Current_Y_PHASE": "A",
    "EM_UPS_Current_B_Phase": "A",
    "EM_UPS_Current_R_Phase": "A",
    "EM_CAR_Charger_Current_R_Phase": "A",
    "EM_CAR_Charger_Current_Y_Phase": "A",
    "EM_CAR_Charger_Current_B_Phase": "A",
    "EM_CAR_Charger_Total_Current": "A",
    "DG_EM_Current_R_Phase": "A",
    "DG_EM_Current_Y_Phase": "A",
    "DG_EM_Current_B_Phase": "A",


    // Power parameters
    "EM_VRV_KW": "kW",
    "EM_Firefighting_kw": "kW",
    "EM_VRB_METER_VOLT_L_L_Avg": "kW",
    "DG_WATT": "kW",
    "DG_Load": "kW",
    "EM_Lift_WATT": "kW",
    "EM_LT_WATT": "kW",
    "EM_TR_Watt": "kW",
    "UPS_POWER_R_Phase": "kW",
    "UPS_POWER_Y_Phase": "kW",
    "UPS_POWER_B_Phase": "kW",
    "Solar_Active_Power": "kW",
    "DG_EM_WATT": "kW",
    "DG_EM_Load": "kW",
    "EM_UPS_Watt": "kW",
    "EM_CAR_Charger_WATT": "kW",
    "EM_Light_Power_Schnider_kw": "kW",
    "EM_UPS_Schnider_kw": "kW",
    "EM_SDB_Emergency_Schnider_kw": "kW",


    // Energy parameters
    "EM_VRV_KWH": "kWh",
    "EM_Firefighting_Kwh": "kWh",
    "DG_Metering_WH": "kWh",
    "DG_Weekly_Energy": "kWh",
    "DG_Daily_Energy": "kWh",
    "DG_Monthly_Energy": "kWh",
    "DG_Yearly_Energy": "kWh",
    "EM_LIFT_RM_WH": "kWh",
    "EM_LT_PANEL_WH": "kWh",
    "EM_TR_WH": "kWh",
    "Solar_Today_Solar_Energy": "kWh",
    "Solar_Total_Solar_Energy": "kWh",
    "DG_EM_Metering_WH": "kWh",
    "EM_UPS_WH": "kWh",
    "EM_CAR_Charger_WH": "kWh",
    "EM_Light_Power_Schnider_Meter_Kwh": "kWh",
    "EM_UPS_Schnider_Meter_1_KWH": "kWh",

    // Power Factor parameters
    "EM_VRV_PF": "",
    "EM_Firefighting_PF": "",
    "EM_Lift_AV_PF": "",
    "EM_LT_AV_PF": "",
    "EM_TR_AV_PF": "",
    "DG_AV_PF": "",
    "DG_Power_Factor": "",
    "DG_EM_Power_Factor": "",
    "DG_EM_AV_PF": "",
    "EM_UPS_AV_PF": "",
    "EM_CAR_Charger_AV_PF": "",
    "EM_Light_Power_Schnider_PF": "",
    "EM_UPS_Schnider_PF": "",
    "EM_SDB_Emergency_Schnider_PF": "",

    // Load/Percentage parameters
    "UPS_LOAD_R_Phase": "Kw",
    "UPS_LOAD_Y_Phase": "Kw",
    "UPS_LOAD_B_Phase": "Kw",
    "UPS_O/P_LOAD%": "Kw",
    "UPS_BATERRY_%": "Kw",


    // Status/Binary parameters (no unit needed)
    "SAF_VFD_On_Off": "",
    "SAF_VFD_On_Off_Fbk": "",
    "SAF_VFD_AM_Fbk": "",
    "Electric_Heater_Ctrl": "",
    "UVGI_Cntrl": "",
    "Electric_Heater_Cntrl_SS": "",
    "UVGI_Cntrl_SS": "",
    "SAF_VFD_Trip_SS_Alarm": "",
    "Post_Filter_SS": "",
    "Heater_Bank_1_Status": "",
    "Heater_Bank_2_Status": "",
    "Heater_Bank_3_Status": "",
    "AHU_On_Off_SS_Panel": "",
    "AHU_Manual_CMD": "",
    "AHU_Schedule": "",
    "AHU_AM_SS": "",
    "AHU_Trip_SS_Alarm": "",
    "AHU_Run_SS": "",
    "AHU_Filter_SS": "",
    "AHU_ONOFF_CMD": "",
    "EXHAUST_FAN_Run_SS": "",
    "EXHAUST_FAN_On_Off_SS": "",
    "EXHAUST_Base_Schedule": "",
    "EXHAUST_FAN_On_Off_Cmd": "",
    "EXHAUST_FAN_AM_SS": "",
    "EXHAUST_BASE_Manual_Cmd": "",
    "DISEL_Am_SS": "",
    "Fire_Alarm": "",
    "UPS_SS": "",
    "UPS_Online": "",
    "TRF_On_Off_SS": "",
    "TRF_Trip_SS_Alarm": "",
    "TANK_High_SS": "",
    "TANK_Low_SS": "",
    "Water_Tank_High_Lvl_SS": "",
    "Water_Tank_Low_Lvl_SS": "",
  };

  // Function to get unit for a parameter
  const getParameterUnit = (paramName) => {
    return parameterUnitMap[paramName] || "";
  };

  const handleDeviceChange = (name, id) => {
    setSelectedDeviceName(name);
    setSelectedDeviceId(id);
    setAge3("");
    setIsDisabled(true);
    setSelectedDeviceParams([]);

    // find the device object (from extractedDevices or filteredDeviceList)
    const device =
      extractedDevices.find((d) => d.id === id) ||
      filteredDeviceList.find((d) => d.id === id) ||
      filteredDeviceList.find((d) => d.name === name) ||
      extractedDevices.find((d) => d.name === name);

    const type = device?.ssType || "";

    const params = parameterMap[type] || [];
    setDeviceParameters(params);
    console.log("Selected device:", name, "type:", type, "params:", params);
  };


  const handleDevParamReports = (apiResponse, type) => {
    let rows = [];

    if (!apiResponse || !Array.isArray(apiResponse.graphData)) {
      return { Headings: {}, RowData: [] };
    }

    apiResponse.graphData.forEach((deviceGroup) => {
      Object.keys(deviceGroup).forEach((paramName) => {
        const paramList = deviceGroup[paramName];
        if (Array.isArray(paramList)) {
          paramList.forEach((entry) => {
            console.log("entry", entry);
            const [date, time] = entry.measured_time.split(" ");
            let value = entry.param_value;
            let parsedValue = parseFloat(value);
            let displayValue;

            if (entry.parameter === "FAU_On_Off") {
              if (value.toLowerCase() === "inactive") {
                displayValue = "OFF";
              } else if (value.toLowerCase() === "active") {
                displayValue = "ON";
              } else {
                displayValue = value;
              }
            } else {
              displayValue = isNaN(parsedValue)
                ? value
                : Number(parsedValue.toFixed(2));
            }

            // ✅ Get unit from mapping
            const unit = getParameterUnit(paramName);
            const valueWithUnit = unit ? `${displayValue} ${unit}` : displayValue;

            rows.push({
              DeviceName: entry.devicename,
              Date: date,
              Time: time,
              ParamName: paramName,
              Value: valueWithUnit, // ✅ Now includes unit
            });
          });
        }
      });
    });

    return {
      Headings: [
        {
          field: "DeviceName",
          width: "150px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        },
        {
          field: "Date",
          width: "100px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        },
        {
          field: "Time",
          width: "100px",
          sortable: true,
          filter: "agNumberColumnFilter",
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        },
        {
          field: "ParamName",
          width: "150px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        },
        {
          field: "Value",
          width: "150px",
          sortable: true,
          lockPosition: "left",
          cellStyle: { "border-right-color": "#e2e2e2" },
        },
      ],
      RowData: rows,
    };
  };
  useEffect(() => {
    async function fetchData() {
      try {
        // ✅ Filter and sort buildings
        let b_data = data
          .filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_BUILDING")
          .sort((a, b) => (a.name > b.name ? 1 : -1));

        if (b_data.length > 0) {
          setSelectedBuilding(b_data[0].uuid); // ✅ Set first building as default
        }
        setBdata(b_data);

        // ✅ Filter and sort floors
        let f_data = data
          .filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_FLOOR")
          .sort((a, b) => (a.name > b.name ? 1 : -1));

        setFloors(f_data); // ✅ Store floors in state

        let z_data = data
          .filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_ZONE")
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        setzones(z_data);
        const res = await api.floor.cpmGetDevData();
        setApiResponse(res);
        if (res) {
          let arr = [];
          let types = Object.keys(res);

          for (let i = 0; i < types.length; i++) {
            EqpArr.map((eqp) => {
              if (eqp.ss_type === types[i]) {
                arr.push(eqp);
              }
            });
          }

          setEquipmentTypes((prev) => (prev.length === 0 ? arr : prev));

          // ✅ If equipment is selected, fetch devices
          if (selectedEquipment && res[selectedEquipment]) {
            const devices = Object.values(res[selectedEquipment]); // ✅ Convert object to array

            // ✅ Filter devices belonging to the selected floor
            const filteredDevices = devices
              .filter((device) => device.Equipment_Group === selectedFloor)
              .sort((a, b) => a.name.localeCompare(b.name));

            // ✅ Store filtered devices as an array of objects [{ id, name }]
            const formattedDevices = filteredDevices.map((device) => ({
              id: device.id,
              name: device.name,
            }));

            setFilteredDeviceList(formattedDevices); // ✅ Update device dropdown
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    fetchData(); // ✅ Call function inside useEffect
  }, [data]); // ✅ Dependencies

  const handleReportSelection = (myapi, option) => {
    setStitle(option);
    switch (option) {
      case "DeviceCritical":
        api["reports"]["critical_table"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;

      case "DeviceTypeCritical":
        api["reports"]["Device_critical"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "mostActiveAlarmCritical":
        api["reports"]["active_alarm"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "restorecriticalalarms":
        api["reports"]["restore_critical_alarm"]().then((res) => {
          // console.log("------------------------>critical alarm",res)
          setReportData(prepareReportData(res));
        });
        break;
      case "RunHours":
        api["reports"]["runhours_report"]().then((res) => {
          // console.log("------------------------>critical alarm",res)
          const preparedData = prepareReportData(res, "RunHours");
          setReportData(preparedData);
        });
        break;
      case "alarmDevice":
        // api['reports']['noncritical_table']().then(res => {
        //   console.log("res------------------------>>>>>>>>>>>>>>",res)
        //   const combinedData = res.map(alarm => {
        //     const possibleCauses = JSON.parse(alarm.possible_causes);
        //     console.log("possible_causes",possibleCauses)
        //     const noncriticalItems = possibleCauses.map(item => {
        //       const formattedItems = Object.entries(item).map(([key, value]) => `- ${key}: ${value}`);
        //       // console.log(formattedItems.join('\n'));
        //       return formattedItems.join('\n');
        //     });

        //     return {
        //       DeviceName: alarm.DeviceName,
        //       Parameter: alarm.Description,
        //       created_at: alarm.created_at,
        //       date: alarm.date,
        //       possible_causes: noncriticalItems.join('\n') // Join items with double newlines
        //     };
        //   });
        api["reports"]["noncritical_table"]().then((res) => {
          const combinedData = res.map((alarm) => {
            let possibleCauses = [];

            // Check if possible_causes is defined and parse it
            if (alarm.possible_causes) {
              try {
                possibleCauses = JSON.parse(alarm.possible_causes);
              } catch (error) {
                console.error(
                  "Invalid JSON format in possible_causes:",
                  alarm.possible_causes
                );
                possibleCauses = []; // Default to an empty array if parsing fails
              }
            } else {
              // console.warn("possible_causes is undefined for alarm:", alarm);
            }

            // Map over possibleCauses if it's an array
            const noncriticalItems = Array.isArray(possibleCauses)
              ? possibleCauses.map((item) => {
                // Ensure item is an object before processing
                if (typeof item === "object" && item !== null) {
                  const formattedItems = Object.entries(item).map(
                    ([key, value]) => `- ${key}: ${value}`
                  );
                  return formattedItems.join("\n");
                }
                return ""; // Return an empty string if item is not an object
              })
              : [];

            return {
              DeviceName: alarm.DeviceName,
              Parameter: alarm.Description,
              created_at: alarm.created_at,
              date: alarm.date,
              possible_causes:
                noncriticalItems.length > 0
                  ? noncriticalItems.join("\n\n")
                  : "null", // Join items with double newlines
            };
          });

          const updatedReportData = prepareReportData(combinedData);
          // console.log("updated=============", updatedReportData);
          setReportData(updatedReportData);
        });
        break;

      case "alarmDeviceType":
        api["reports"]["device_nonCritical"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "mostActiveAlarmNonCritical":
        api["reports"]["non_criticalalarm"]().then((res) => {
          const combinedData = res.map((alarm) => {
            const possibleCauses = JSON.parse(alarm.possible_causes);
            const noncriticalItems = possibleCauses.map((item) => {
              const formattedItems = Object.entries(item).map(
                ([key, value]) => `- ${key}: ${value}`
              );
              // console.log(formattedItems.join('\n'));
              return formattedItems.join("\n");
            });

            return {
              DeviceName: alarm.DeviceName,
              Parameter: alarm.Description,
              created_at: alarm.created_at,
              date: alarm.date,
              Possible_Causes: noncriticalItems.join("\n"), // Join items with double newlines
            };
          });

          const updatedReportData = prepareReportData(combinedData);
          // console.log("updated=============", updatedReportData);
          setReportData(updatedReportData);
        });
        break;

      case "restorenoncriticalalarms":
        api["reports"]["restore_noncritical_alarm"]().then((res) => {
          setReportData(prepareReportData(res));
        });

        break;
      case "RunHours":
        api["reports"]["runhours_report"]().then((res) => {
          const preparedData = prepareReportData(res);
          setReportData(preparedData);
        });
        break;
      case "ibmsevents":
        api["reports"]["ibmsevents_table"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "UserControlDetails":
        api["reports"]["user_control_deatils"]().then((res) => {
          setReportData(prepareUserReportData(res));
        });
        break;
      case "AcknowledgedUser":
        api["reports"]["acknowledged_by_user"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "IgnoredUser":
        api["reports"]["ignored_by_user"]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
      case "UserLoginReport":
        api["reports"]["login_login_details"]().then((res) => {
          setReportData(prepareUserLoginReportData(res));
        });
        break;
      case "Device Reports":
        if (option === "Device Reports") {
          const headings = getColumns(null, true);
          // headings.splice(2, 1, "Date", "Time"); // Replace "Measured Time" with "Date" and "Time"
          let rowData;
          setReportData({ Headings: headings, RowData: rowData });
        } else {
          // For other report options, use default headings and columns
          setReportData(prepareReportData(tableData)); // Pass tableData here
        }

        break;
      default:
        // api['reports']['ibmsevents_table']().then(res => {
        //   setReportData(prepareReportData(res))
        // })
        setReportData([]);
        break;
      case "IgnoredUser":
        api["reports"][""]().then((res) => {
          setReportData(prepareReportData(res));
        });
        break;
    }
  };

  const onFirstDataRendered1 = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const onBtExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);
  const sizeToFit = useCallback(() => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const autoSizeAll = useCallback((skipHeader) => {
    const allColumnIds = [];
    gridRef.current.columnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.getColId());
    });
    gridRef.current.columnApi.autoSizeColumns(allColumnIds, skipHeader);
  }, []);

  const onSelectionChanged = useCallback((event) => {
    // setSelectedRows(event.api.getSelectedRows());
    // window.alert('selection changed, ' + rowCount + ' rows selected');
  }, []);
  const downloadAsPdf = () => {
    const doc = new jsPDF();

    const hasDateField = reportData.Headings.some(
      (column) => column.field === "date"
    );
    const hasTimeField = reportData.Headings.some(
      (column) => column.field === "time"
    );
    const activeTimeField = reportData.Headings.find(
      (column) => column.field === "activeTime"
    );

    const tableData = reportData.RowData.map((row) => {
      const newRow = [];

      // Check if it's the RunHours report
      const isRunHours = reportData.Headings.some(
        (column) => column.field === "Run Hour"
      );

      if (isRunHours) {
        // Push only the relevant fields for RunHours
        newRow.push(row["device_name"]); // Assuming 'device_name' is the Equipment Name
        newRow.push(row["run_hour"]); // Assuming 'run_hour' is the Run Hours
      } else {
        // Non-RunHours report handling
        const hasDateField = reportData.Headings.some(
          (column) => column.field === "date"
        );
        const hasTimeField = reportData.Headings.some(
          (column) => column.field === "time"
        );
        const activeTimeField = reportData.Headings.some(
          (column) => column.field === "activeTime"
        );

        if (!activeTimeField && hasDateField) {
          newRow.push(row.date !== undefined ? row.date : "");
        }

        if (!activeTimeField && hasTimeField) {
          newRow.push(row.time !== undefined ? row.time : "");
        }

        reportData.Headings.forEach((column) => {
          if (
            column.field !== "date" &&
            column.field !== "time" &&
            column.field !== "activeTime" &&
            row.hasOwnProperty(column.field)
          ) {
            newRow.push(row[column.field]);
          }
        });
      }

      return newRow;
    });

    const presentColumns = reportData.Headings.filter((column) => {
      return (
        column.field !== "date" &&
        column.field !== "time" &&
        column.field !== "activeTime" &&
        reportData.RowData[0]?.hasOwnProperty(column.field)
      );
    });

    const rearrangedPdfHeaders = [
      ...(activeTimeField ? [] : hasDateField ? ["Date"] : []), // Place the "Date" header first if "activeTime" is absent and "date" is present
      ...(activeTimeField ? [] : hasTimeField ? ["Time"] : []), // Place the "Time" header second if "activeTime" is absent and "time" is present
      ...presentColumns.map((column) => column.field),
    ];

    // ... (continue with your existing code)

    // console.log("tabledata",tableData)

    const headers = reportData.Headings.map((column) => column.field);

    // const startX = 5;
    const imgData = require("../../assets/Images/logo.png");
    const imgData1 = imgData;

    const logoWidth = 30; // Common width for both logos
    const logoHeight = 30; // Common height for both logos

    const startX1 = 5; // Position for first logo
    const startY1 = -7;

    const startX = 152; // Position for second logo
    const startY = -7;

    // doc.addImage(imgData1, "PNG", startX1, startY1, logoWidth, logoHeight);
    // doc.addImage(imgData, "PNG", startX, startY, logoWidth, logoHeight);

    const currentDate = new Date();

    // Get current date in "dd/mm/yyyy" format
    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
    const year = currentDate.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    // Get current time in "hh:mm AM/PM" format
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${ampm}`;

    const currentDateTime = `${formattedDate} ,${formattedTime}`;

    const timestampX = doc.internal.pageSize.width - 15; // X position at the top right
    const timestampY = 22; // Y position at the top
    const timestampFontSize = 10; // Adjust the font size as needed

    doc.setFontSize(timestampFontSize);
    doc.text(currentDateTime, timestampX, timestampY, { align: "right" });

    doc.autoTable({
      head: [rearrangedPdfHeaders],
      body: tableData,
      startY: 25, // Adjust this as needed
      theme: "striped", // Optional, choose a theme for the table
      styles: {
        halign: "left", // Center-align column headers
        cellPadding: 2, // Adjust cell padding as needed
        // Define border styles
        valign: "middle", // Vertical alignment
        lineWidth: 0.1, // Width of the table borders
        // lineColor: [0, 0, 0], // Color of the table borders (black in this case)
        // fillStyle: 'F', // Fill the table cells with color
        // textColor: [0, 0, 0], // Text color
      },
      // columnStyles: columnWidths, // Apply custom column widths
      margin: { top: 5 }, // Adjust the margin as needed
    });
    // const customerName = "TEPL"; // Replace with actual customer name
    const downloadedBy = `Downloaded by: ${username}`; // Replace with actual name

    // Calculate the width of the customer name and "downloaded by" text
    // const customerNameWidth = doc.getStringUnitWidth(customerName) * doc.internal.getFontSize() / doc.internal.scaleFactor;
    const downloadedByWidth =
      (doc.getStringUnitWidth(downloadedBy) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor;

    // Calculate total width of the text
    const totalTextWidth = Math.max(downloadedByWidth);

    // Center alignment calculations
    const centerX = doc.internal.pageSize.width / 2;

    // Positioning for customer name and "Downloaded by" text on the first page
    const firstPageTextX = centerX - totalTextWidth / 2; // Center the text horizontally
    const firstPageTextY = 15; // Fixed position at the top
    const downloadedByY = firstPageTextY + 6;

    // Set font size for the text
    const textFontSize = 12; // Adjust the font size as needed
    const Font = "Arial";
    doc.setFontSize(textFontSize);
    doc.setFont(Font);

    // Render the text on the first page only
    const totalPages = doc.internal.getNumberOfPages();
    for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
      doc.setPage(pageNumber);
      if (pageNumber === 1) {
        // doc.text(`Customer Name: ${customerName}`, firstPageTextX, firstPageTextY);
        doc.text(downloadedBy, firstPageTextX, downloadedByY); // Adjust vertical position
      }
    }
    const totalPages1 = doc.internal.getNumberOfPages();

    // Iterate through each page and add pagination
    for (let pageNumber = 1; pageNumber <= totalPages1; pageNumber++) {
      doc.setPage(pageNumber);

      // Calculate the x and y positions for the pagination
      const paginationX = doc.internal.pageSize.width - 15; // X position at the top right
      const paginationY = doc.internal.pageSize.height - 10; // Y position at the bottom

      // Add the page number to the current page
      doc.setFontSize(10);
      doc.text(
        `Page ${pageNumber} of ${totalPages1}`,
        paginationX,
        paginationY,
        { align: "right" }
      );
    }

    const filename = `${stitle}.pdf`;
    doc.save(filename);
  };

  const getFilteredData = () => {
    const rows = reportData?.RowData || [];
    // console.log("rowwwwwwwwwwwwww",reportData)
    if (age3 === "Device Reports") {
      return rows.filter((row) => row.deviceReport === true);
    }

    return rows;
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleChange1 = (event) => {
    setAge1(event.target.value);
  };

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    setAge3(selectedValue);

    if (!selectedDeviceId) {
      console.error("No device selected!");
      return;
    }

    setIsDisabled(false);

    const intervalMapping = {
      "1 Day": "1 DAY",
      "1 week": "1 WEEK",
      "1 month": "1 MONTH",
      "3 months": "3 MONTH",
      "6 months": "6 MONTH",
      "1 year": "1 YEAR",
    };

    const interval = intervalMapping[selectedValue];

    if (!interval) {
      console.warn("Invalid selection");
      return;
    }

    if (selectedDeviceParams.length > 0) {
      // Device Parameters Report API
      axios
        .post(
          // `https://localhost:9443/v1/gl_analytics/${selectedDeviceId}/deviceParametersReports`,
          //to run locally use below url
          //`http://localhost/v1/gl_analytics/${selectedDeviceId}/deviceParametersReports`,
          `/v1/gl_analytics/${selectedDeviceId}/deviceParametersReports`,
          // while giving build no localhost should not be given so use above url
          {
            interval: interval,
            parameters: selectedDeviceParams,
          }
        )
        .then((res) => {
          console.log("postresponse", res.data);
          setReportData(handleDevParamReports(res.data, "MosesJugad"));
          setDevParamReports(res.graphData[0]);
          const graphData = res.data.graphData;
          setReportData(res); // or any transform function
        })
        .catch((err) => {
          console.error(
            "Error fetching device parameter reports:",
            err,
            selectedDeviceId
          );
        });
    } else {
      // fallback to old alarm reports
      switch (selectedValue) {
        case "1 Day":
          api.alarmreports.alarmsfor1day(selectedDeviceId).then((res) => {
            setTableData(res);
            setReportData(prepareReportData(res));
          });
          break;
        case "1 week":
          api.alarmreports.alarmsfor1week(selectedDeviceId).then((res) => {
            setWeek1(res);
            setReportData(prepareReportData(res));
          });
          break;
        case "1 month":
          api.alarmreports.alarmsfor1month(selectedDeviceId).then((res) => {
            setMonth1(res);
            setReportData(prepareReportData(res));
          });
          break;
        case "3 months":
          api.alarmreports.alarmsfor3months(selectedDeviceId).then((res) => {
            setMonth3(res);
            setReportData(prepareReportData(res));
          });
          break;
        case "6 months":
          api.alarmreports.alarmsfor6months(selectedDeviceId).then((res) => {
            setMonth6(res);
            setReportData(prepareReportData(res));
          });
          break;
        case "1 year":
          api.alarmreports.alarmsfor1year(selectedDeviceId).then((res) => {
            setYear1(res);
            setReportData(prepareReportData(res));
          });
          break;
        default:
          console.warn("Invalid selection");
      }
    }
  };

  // const handleDropdownChange = (event) => {
  //   const selectedValue = event.target.value;
  //   setAge3(selectedValue);

  //   if (!selectedDeviceId) {
  //     console.error("No device selected!");
  //     return;
  //   }
  //   setIsDisabled(false);
  //   // console.log(`Fetching data for ${selectedValue} with Device ID:`, selectedDeviceId);

  //   switch (selectedValue) {
  //     case "1 Day":
  //       api.alarmreports.alarmsfor1day(selectedDeviceId).then((res) => {
  //         setTableData(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     case "1 week":
  //       api.alarmreports.alarmsfor1week(selectedDeviceId).then((res) => {
  //         setWeek1(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     case "1 month":
  //       api.alarmreports.alarmsfor1month(selectedDeviceId).then((res) => {
  //         setMonth1(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     case "3 months":
  //       api.alarmreports.alarmsfor3months(selectedDeviceId).then((res) => {
  //         setMonth3(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     case "6 months":
  //       api.alarmreports.alarmsfor6months(selectedDeviceId).then((res) => {
  //         setMonth6(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     case "1 year":
  //       api.alarmreports.alarmsfor1year(selectedDeviceId).then((res) => {
  //         setYear1(res);
  //         setReportData(prepareReportData(res));
  //       });
  //       break;
  //     default:
  //       console.warn("Invalid selection");
  //   }
  // };

  const handleEquipmentChange = (event) => {
    const selectedValue = event.target.value;
    setIsDisabled(true);

    // resolve ss_type if user selected descriptive name or ss_type
    const eqpItem =
      EqpArr.find((e) => e.ss_type === selectedValue) ||
      EqpArr.find(
        (e) =>
          e.name.toLowerCase() === String(selectedValue).toLowerCase() ||
          e.name.toLowerCase().includes(String(selectedValue).toLowerCase())
      );

    const resolvedSsType = eqpItem ? eqpItem.ss_type : selectedValue;

    setSelectedEquipment(resolvedSsType);

    // filter devices by resolved ssType
    const matchingDevices = extractedDevices.filter(
      (device) => device.ssType === resolvedSsType
    );

    setFilteredDeviceList(matchingDevices);

    // set device parameters for this equipment type
    const params = parameterMap[resolvedSsType] || [];
    setDeviceParameters(params);
    setSelectedDeviceParams([]);
  };

  // const handleDeviceChange = (name, id) => {
  //   setSelectedDeviceName(name);
  //   setSelectedDeviceId(id);
  //   setAge3("");
  //   setIsDisabled(true);
  // };

  const handlefloorchange = (name, id) => {
    setDName(name);
    setDeviceid(id);
    setFId(id);
    setFdata(name);
    let z_data = [],
      d_data = [];
    data.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
    data.filter((_each, i) => {
      if (
        _each.zone_type === "GL_LOCATION_TYPE_ZONE" &&
        _each.zone_parent === id
      ) {
        z_data.push(_each);
        data.filter((eachObj) => {
          if (eachObj.zone_parent === _each.uuid) {
            if (eachObj.zone_type == "NONGL_SS_AIR_COOLED_CHILLER") {
              d_data.push(eachObj);
            }
          }
        });
      }
      d_data.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      setDData(d_data);
    });
  };

  const handleformatChange = (selectedformat) => {
    setFormat(selectedformat);

    if (selectedformat === "download_csv") {
      onBtExport(); // Function to handle CSV download
    } else if (selectedformat === "download_pdf") {
      const doc = new jsPDF();

      // Check if it's the RunHours report
      const isRunHours = reportData.Headings.some(
        (column) =>
          column.field === "Run Hours" || column.field === "Equipment Name"
      );

      let tableData;

      if (isRunHours) {
        // Prepare table data for RunHours report
        tableData = reportData.RowData.map((row) => {
          return [row["Equipment Name"], row["Run Hours"]]; // Only include Equipment Name and Run Hours
        });
        console.log("RunHours Table Data:", tableData);
      } else {
        // Prepare table data for other reports
        tableData = reportData.RowData.map((row) => {
          return reportData.Headings.map((column) => row[column.field]); // Include all fields for other reports
        });
      }

      // Define headers based on the report type
      const pdfHeaders = isRunHours
        ? ["Equipment Name", "Run Hours"]
        : reportData.Headings.map((column) => column.field);

      // Add logos to the PDF
      const imgData = require("../../assets/Images/logo.png"); // Local logo
      const imgData1 = imgData; // Assuming kauvery_logo is imported

      const logoWidth = 50;
      const logoHeight = 30;

      // doc.addImage(imgData1, "PNG", 5, -7, logoWidth, logoHeight); // First logo
      // doc.addImage(imgData, "PNG", 152, -7, logoWidth, logoHeight); // Second logo

      // Add the table to the PDF
      doc.autoTable({
        head: [pdfHeaders],
        body: tableData,
        startY: 25,
        theme: "striped",
        styles: {
          halign: "left",
          cellPadding: 2,
          valign: "middle",
          lineWidth: 0.1,
        },
        margin: { top: 10 },
      });

      // Current Date and Time
      const currentDate = new Date();
      const day = currentDate.getDate().toString().padStart(2, "0");
      const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
      const year = currentDate.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      const hours = currentDate.getHours();
      const minutes = currentDate.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedTime = `${hours % 12 || 12}:${minutes} ${ampm}`;

      const currentDateTime = `${formattedDate}, ${formattedTime}`;

      // Add Date-Time at the top right
      doc.setFontSize(10);
      doc.text(currentDateTime, doc.internal.pageSize.width - 15, 22, {
        align: "right",
      });

      // Add Downloaded By
      const downloadedBy = `Downloaded by: ${username}`; // username must be available
      const downloadedByWidth =
        (doc.getStringUnitWidth(downloadedBy) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const centerX = doc.internal.pageSize.width / 2;

      doc.setFontSize(12);
      doc.setFont("Arial", "normal");

      const firstPageTextX = centerX - downloadedByWidth / 2;
      const firstPageTextY = 21;

      const totalPages = doc.internal.getNumberOfPages();

      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        doc.setPage(pageNumber);
        if (pageNumber === 1) {
          doc.text(downloadedBy, firstPageTextX, firstPageTextY);
        }
      }

      // Add page numbers
      for (let pageNumber = 1; pageNumber <= totalPages; pageNumber++) {
        doc.setPage(pageNumber);
        if (pageNumber === 1) {
          // doc.text(`Customer Name: ${customerName}`, firstPageTextX, firstPageTextY);
          doc.text(downloadedBy, firstPageTextX, firstPageTextY); // Adjust vertical position
        }
      }

      const totalPages1 = doc.internal.getNumberOfPages();

      // Iterate through each page and add pagination
      for (let pageNumber = 1; pageNumber <= totalPages1; pageNumber++) {
        doc.setPage(pageNumber);

        // Calculate the x and y positions for the pagination
        const paginationX = doc.internal.pageSize.width - 15; // X position at the top right
        const paginationY = doc.internal.pageSize.height - 10; // Y position at the bottom

        // Add the page number to the current page
        doc.setFontSize(10);
        doc.text(
          `Page ${pageNumber} of ${totalPages1}`,
          paginationX,
          paginationY,
          { align: "right" }
        );
      }

      // Save the PDF
      doc.save("report.pdf");
    }
  };

  const handleFloorChange = (event) => {
    const floorId = event.target.value;

    setSelectedFloor(floorId);
    setIsEquipmentDisabled(false); // Enable Equipment dropdown
    setIsDisabled(true);

    const devices = [];
    const ssTypeSet = new Set();

    // ✅ Only match for the selected floor
    const matchingFloor = floors.find((floor) => floor.uuid === floorId);

    if (!matchingFloor) {
      console.warn("No matching floor found!");
      return;
    }

    Object.keys(apiResponse).forEach((deviceType) => {
      Object.values(apiResponse[deviceType]).forEach((device) => {
        // console.log("device", device);
        // zones.forEach((zone) => {

        if (
          device.Equipment_Group == matchingFloor.uuid

          // && device.uuid === device.Equipment_Group
        ) {
          // console.log("floor", matchingFloor);
          // Push only the matching devices
          devices.push({
            id: device.id || "No ID",
            name: device.name || "No Name",
            ssType: device.ssType || "No ssType",
          });

          if (device.ssType) {
            ssTypeSet.add(device.ssType);
          }
        }
        // });
      });
    });
    console.log("object", devices);
    // You can now use extractedDevices and ssTypeSet as needed
    setExtractedDevices(devices);
  };

  const handleBuildingChange = (event) => {
    const selectedId = event.target.value;
    const selectedName =
      bdata.find((item) => item.uuid === item.selectedId)?.name || "";

    setSelectedBuilding(selectedId);
    setSelectedBuildingName(selectedName);
    setIsDisabled(true);
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={1}>
          <Grid item xs={12} sm={12} md={5} lg={5} xl={5} xxl={5}>
            <FormControl
              variant="filled"
              className={classes.formControl}
              style={{
                width: "max-content",
                minWidth: "100%",
                backgroundColor: "#eeeef5",
                marginLeft: "0vh",
              }}
            >
              <Select
                labelId="filled-hidden-label-small"
                id="demo-simple-select-outlined"
                label="Floor"
                value={stitle || ""}
                style={{ fontWeight: "bold", borderRadius: "0.8vw" }}
                // onChange={handlefloorchange}
                className={classes.select}
                MenuProps={{ classes: { paper: classes.menuPaper } }}
                disableUnderline
              >
                {reportOptions.map((_item) =>
                  _item.title !== "User Login Report" ||
                    _item.title !== "Trend Log Comparision Report" ||
                    _item.title !== "Schedule Activity Report" ||
                    _item.title !== "Activites Per User Report" ||
                    _item.title !== "Activites Per Server Report" ? (
                    <MenuItem
                      key={_item.option}
                      value={_item.option}
                      onClick={() =>
                        handleReportSelection(_item.api, _item.option)
                      }
                    >
                      {_item.title}
                    </MenuItem>
                  ) : (
                    <MenuItem
                      key={_item.option}
                      value={_item.option}
                      style={{ backgroundColor: "Gray" }}
                    >
                      {_item.title}
                    </MenuItem>
                  )
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}></Grid>
          {/* <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}></Grid> */}
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start", // Align left
                alignItems: "center",
                flexWrap: "nowrap", // Prevent buttons from wrapping to next line
                gap: "8px",
                marginLeft: "-26vh", // Add space between buttons
              }}
            >
              <Button
                color="primary"
                variant={format === "download_csv" ? "contained" : "outlined"}
                onClick={() => handleformatChange("download_csv")}
                style={{
                  padding: "13px 20px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  width: "160px",
                }}
                disabled={stitle === "Device Reports" && isDisabled}
              >
                Export to CSV
              </Button>

              <Button
                color="primary"
                variant={format === "download_pdf" ? "contained" : "outlined"}
                onClick={() => handleformatChange("download_pdf")}
                style={{
                  padding: "13px 20px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  width: "160px",
                }}
                disabled={stitle === "Device Reports" && isDisabled}
              >
                Download as PDF
              </Button>

              <Button
                color="primary"
                onClick={() => sizeToFit()}
                style={{
                  padding: "10px 16px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  width: "120px",
                }}
              >
                Size to Fit
              </Button>

              <Button
                color="primary"
                onClick={() => autoSizeAll(false)}
                style={{
                  padding: "10px 16px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                  width: "140px",
                }}
              >
                Auto-Size All
              </Button>
            </div>
          </Grid>
        </Grid>
      </Grid>
      <div>
        {stitle === "Device Reports" && (
          <div>
            <Grid container item xs={12} spacing={1}>
              {/* <Grid item xs={12} sm={12} md={1} lg={1} xl={1} xxl={1}></Grid> */}
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Building
                  </InputLabel>

                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Building"
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                      fontFamily: "Arial",
                      // textAlign: "center",
                      // // Centers the text
                      // "& .MuiSelect-select": {
                      //   textAlign: "center",
                      //   // Centers the selected text
                      // },
                    }}
                    className={classes.select}
                    value={selectedBuilding} // Always display "TEPL"
                    onChange={handleBuildingChange} // Call function on click
                    disableUnderline
                  >
                    {bdata.map((_item) => (
                      <MenuItem key={_item.uuid} value={_item.uuid}>
                        {_item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                >
                  <InputLabel id="floor-label">Floor</InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Building"
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                      fontFamily: "Arial",
                    }}
                    value={selectedFloor}
                    onChange={handleFloorChange}
                    className={classes.select}
                    disableUnderline
                  >
                    {floors.map((floor) => {
                      let displayName = "";

                      if (floor.name.includes("Basement"))
                        displayName = "Basement";
                      else if (floor.name.includes("Ground"))
                        displayName = "Ground";
                      else if (floor.name.includes("First"))
                        displayName = "First";
                      else if (floor.name.includes("Second"))
                        displayName = "Second";
                      else if (floor.name.includes("Third"))
                        displayName = "Third";
                      else if (floor.name.includes("Roof"))
                        displayName = "Terrace";
                      else displayName = floor.name; // fallback to original

                      return (
                        <MenuItem key={floor.name} value={floor.uuid}>
                          {displayName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                  disabled={isEquipmentDisabled} // ✅ Equipment dropdown is disabled until floor is selected
                >
                  <InputLabel id="equipment-select-label">
                    Equipment Type
                  </InputLabel>
                  <Select
                    labelId="equipment-select-label"
                    value={selectedEquipment || ""}
                    onChange={handleEquipmentChange}
                    disableUnderline
                    className={classes.select}
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                      fontFamily: "Arial",
                    }}
                  >
                    {Array.from(
                      new Set(extractedDevices.map((device) => device.ssType))
                    ).map((ssType) => {
                      // Find the alias name from EqpArr
                      const eqpItem = EqpArr.find((eqp) => eqp.ss_type === ssType);
                      const label = eqpItem ? eqpItem.name : ssType.replace(/_/g, " ");

                      return (
                        <MenuItem key={ssType} value={ssType}>
                          {label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                  disabled={!selectedEquipment}
                >
                  <InputLabel id="device-label">Device</InputLabel>
                  <Select
                    labelId="device-label"
                    value={selectedDeviceName || ""}
                    onChange={(event) => {
                      const selectedDevice = filteredDeviceList.find(
                        (device) => device.name === event.target.value
                      );
                      if (selectedDevice) {
                        handleDeviceChange(
                          selectedDevice.name,
                          selectedDevice.id
                        );
                        setSelectedDeviceName(selectedDevice.name);
                      }
                    }}
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                    }}
                    label="Device"
                  >
                    {filteredDeviceList.length === 0 ? (
                      <MenuItem disabled>No devices available</MenuItem>
                    ) : (
                      [...filteredDeviceList] // Make a copy to avoid mutating state
                        .sort((a, b) => a.name.localeCompare(b.name)) // ✅ Sort alphabetically
                        .map((device) => (
                          <MenuItem key={device.id} value={device.name}>
                            {device.name}
                          </MenuItem>
                        ))
                    )}
                  </Select>
                </FormControl>
              </Grid>



              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                  disabled={!selectedDeviceName} // Disable if no device selected
                >
                  <InputLabel id="device-params-label">
                    Device Parameters
                  </InputLabel>
                  <Select
                    labelId="device-params-label"
                    multiple
                    value={selectedDeviceParams}
                    onChange={(e) => {
                      const value = e.target.value;

                      const allIsSelected = value.includes("ALL");

                      const allWereSelected =
                        selectedDeviceParams.length === deviceParameters.length;

                      if (allIsSelected && !allWereSelected) {

                        setSelectedDeviceParams(deviceParameters);
                        setAge3("");
                        setIsDisabled(true);
                      } else if (allIsSelected && allWereSelected) {

                        setSelectedDeviceParams([]);
                        setAge3(""); // Reset time dropdown
                        setIsDisabled(true); // Keep time dropdown disabled
                      } else {
                        // User selected/deselected individual parameters
                        const filteredValue = value.filter((v) => v !== "ALL");
                        setSelectedDeviceParams(filteredValue);

                        // If no parameters selected, disable time dropdown
                        if (filteredValue.length === 0) {
                          setAge3("");
                          setIsDisabled(true);
                        } else {

                          setAge3("");
                          setIsDisabled(true);
                        }
                      }
                    }}
                    renderValue={(selected) => {

                      if (
                        deviceParameters.length > 0 &&
                        selected.length === deviceParameters.length
                      ) {
                        return "All Parameters";
                      }
                      // Otherwise show the selected parameters
                      return selected.join(", ");
                    }}
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                      fontFamily: "Arial",
                    }}
                  >
                    <MenuItem key="all-parameters" value="ALL">
                      <Checkbox
                        checked={
                          deviceParameters.length > 0 &&
                          selectedDeviceParams.length === deviceParameters.length
                        }
                      />
                      <ListItemText primary="Select All" />
                    </MenuItem>
                    {deviceParameters.map((param) => (
                      <MenuItem key={param} value={param}>
                        <Checkbox
                          checked={selectedDeviceParams.indexOf(param) > -1}
                        />
                        <ListItemText primary={param} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>


              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} xxl={2}>
                <FormControl
                  variant="outlined"
                  size="small"
                  className={classes.formControl}
                  style={{
                    width: "100%",
                    backgroundColor: "#eeeef5",
                    fontFamily: "Arial",
                  }}
                >
                  <InputLabel id="demo-simple-select-outlined-label">
                    Time
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    label="Building"
                    style={{
                      fontWeight: "bold",
                      height: "6vh",
                      borderRadius: "0.8vw",
                      fontFamily: "Arial",
                    }}
                    value={age3}
                    className={classes.select}
                    onChange={handleDropdownChange}
                    disableUnderline
                  >
                    <MenuItem value="">
                      <em>Select Time</em>
                    </MenuItem>
                    <MenuItem value="1 Day">1 Day</MenuItem>
                    <MenuItem value="1 week">1 Week</MenuItem>
                    <MenuItem value={"1 month"}>1 Month</MenuItem>
                    <MenuItem value={"3 months"}>3 Months</MenuItem>
                    <MenuItem value={"6 months"}>6 Months</MenuItem>
                    <MenuItem value={"1 year"}>1 Year</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {/* <Grid item xs={12} sm={12} md={1} lg={1} xl={1} xxl={1}></Grid> */}
            </Grid>
            <Grid container item xs={12} spacing={1}>
              <Grid item xs={3}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={3}>
                    <FormControl
                      component="fieldset"
                      variant="filled"
                      size="small"
                      className={classes.formControl}
                      style={{
                        width: "100%",
                        fontFamily: "Arial",
                        display: "flex", // Set display to flex
                        justifyContent: "space-between", // Space evenly between elements
                      }}
                    ></FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        )}
      </div>
      {stitle !== "Device Reports" && (
        <div
          style={{
            display: "flex",
            alignItems: "left",
            justifyContent: "left",
            gap: "10px",
          }}
        >
          <ButtonGroup
            color="primary"
            aria-label="format"
            className={classes.buttonGroup}
            size="small"
          >
            {/* <Button onClick={() => sizeToFit()} size='small' style={{ padding: '4px 10px', fontSize: '12px' }}>
        Size to Fit
      </Button>
      <div style={{ margin: '0 3px' }}></div>
      <Button onClick={() => autoSizeAll(false) } style={{ padding: '4px 10px', fontSize: '12px' }}>Auto-Size All</Button> */}
          </ButtonGroup>
          {/* <ButtonGroup
      color="primary"
      aria-label="format"
      className={classes.buttonGroup}
      size="small"
    >
      <Button onClick={() => onBtExport()} size='small' style={{ padding: '4px 10px', fontSize: '12px' }}>
        Export to CSV
      </Button>
      <div style={{ margin: '0 3px' }}></div>
      <Button onClick={() => downloadAsPdf()} size="small"style={{ padding: '4px 10px', fontSize: '12px' }} >Download as PDF</Button>
    </ButtonGroup> */}
        </div>
      )}

      {isloaded === false ? (
        <div style={{ textAlign: "center", marginTop: "150px" }}>
          <CircularProgress className={classes.loader} />
        </div>
      ) : (
        <div
          className="ag-theme-alpine"
          style={{ height: 450, width: "100%", marginTop: "1vh" }}
        >
          <AgGridReact
            ref={gridRef}
            // rowData={reportData["RowData"]}
            // rowData={age3 === "Device Reports" ? deviceReportData : reportData["RowData"]} // Use deviceReportData only for "Device Reports" option
            rowData={getFilteredData()}
            columnDefs={reportData["Headings"]}
            rowSelection={"multiple"}
            onSelectionChanged={onSelectionChanged}
            pagination={true}
            paginationPageSize={10}
            onFirstDataRendered={onFirstDataRendered1}
            suppressMovable="true"
            suppressMenuHide="true"
          ></AgGridReact>
        </div>
      )}
    </div>
  );
}

export default GlEventsViewer;
